<template>
  <b-overlay :show="loading">
    <b-card @click="linkRota != '' ? $router.push({ name: linkRota, query: { statusPedido: statusPedido } }) : ''" :border-variant="color" class="order-card-border">
      <b-card-text class="d-flex align-items-center justify-content-between">
        <b-row>
          <b-col cols="12" class="mb-2">
            <span>
              <i v-if="icon" :class="`${icon} mr-2`"></i> {{ text }}
            </span>
          </b-col>
          <b-col>
            <slot :quantity="quantity">
              <span class="font-weight-bold fs-18">
                {{ quantity }}
              </span>
            </slot>
          </b-col>
        </b-row>
      </b-card-text>
    </b-card>
  </b-overlay>
</template>

<script>
export default {
  name: 'OrderCard',
  props: {
    text: {
      type: String,
      required: true,
    },
    quantity: {
      type: String | Number,
      default: 0,
    },
    color: {
      type: String,
      default: 'primary',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    linkRota: {
      type: String,
      required: false,
      default: ''
    },
    statusPedido: {
      type: String,
      required: false,
      default: ''
    },
    type: {
      type: Number,
    },
    icon: String,
  },

  methods: {
    selectClient() {
      this.type == 1 ? this.$emit('isSelectClient') : this.$emit('isSelectProfessional');
    }
  }
};
</script>

<style scoped>
.order-card-border {
  border-width: 3px !important;
}
</style>
